import { useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowRight, ChevronDown, Menu, MessageCircle } from "lucide-react";
import { brandProtectionServices, sourcingRequestPath, supplyChainServices } from "../content/services";
import { business } from "../content/business";
import { BrandLogo } from "./BrandLogo";
import "./navigation.css";

function ServiceLinks() {
  return <div className="nsc-nav-services-grid">
    <div><h2>Supply Chain</h2><ul>{supplyChainServices.map(service => <li key={service.path}><Link to={service.path}>{service.name}<ArrowRight size={14} aria-hidden="true" /></Link></li>)}</ul><Link to="/services/" className="nsc-nav-all">Explore all services<ArrowRight size={14} aria-hidden="true" /></Link></div>
    <div><h2>Brand Protection</h2><ul>{brandProtectionServices.map(service => <li key={service.path}><Link to={service.path}>{service.name}<ArrowRight size={14} aria-hidden="true" /></Link></li>)}</ul></div>
  </div>;
}

export function Navbar() {
  const root = useRef<HTMLElement>(null);
  const location = useLocation();
  useEffect(() => {
    root.current?.querySelectorAll<HTMLDetailsElement>("details[open]").forEach(detail => { detail.open = false; });
  }, [location.pathname, location.hash]);
  useEffect(() => {
    const close = (event: KeyboardEvent | PointerEvent) => {
      if (event instanceof KeyboardEvent && event.key !== "Escape") return;
      if (event instanceof PointerEvent && root.current?.contains(event.target as Node)) return;
      root.current?.querySelectorAll<HTMLDetailsElement>("details[open]").forEach(detail => {
        detail.open = false;
        if (event instanceof KeyboardEvent) detail.querySelector("summary")?.focus();
      });
    };
    document.addEventListener("keydown", close);
    document.addEventListener("pointerdown", close);
    return () => { document.removeEventListener("keydown", close); document.removeEventListener("pointerdown", close); };
  }, []);
  return <header ref={root} className="nsc-header" data-track-location="header">
    <div className="nsc-header-inner">
      <Link to="/" aria-label="Nexus Supply Chain home" className="nsc-nav-logo"><BrandLogo variant="symbol" priority className="h-auto w-full" /></Link>
      <nav className="nsc-desktop-nav" aria-label="Primary navigation">
        <details className="nsc-services-menu"><summary>Services<ChevronDown size={14} aria-hidden="true" /></summary><div className="nsc-mega-menu"><ServiceLinks /></div></details>
        <Link to="/how-nexus-works/">How it works</Link><Link to="/why-nexus/">Why NEXUS</Link>
      </nav>
      <div className="nsc-nav-actions">
        <a className="nsc-nav-whatsapp" href={business.whatsappUrl} target="_blank" rel="noopener noreferrer" aria-label="Message us on WhatsApp"><MessageCircle size={17} aria-hidden="true" /><span>WhatsApp</span></a>
        <Link className="nsc-nav-start" to={sourcingRequestPath}>Start a Sourcing Request</Link>
        <details className="nsc-mobile-nav">
          <summary aria-label="Toggle navigation menu"><Menu size={23} aria-hidden="true" /></summary>
          <nav className="nsc-mobile-panel" aria-label="Mobile navigation">
            <ServiceLinks />
            <div className="nsc-mobile-pages"><Link to="/how-nexus-works/">How it works</Link><Link to="/why-nexus/">Why NEXUS</Link><Link to="/about/">About NEXUS</Link></div>
            <a href={business.whatsappUrl} target="_blank" rel="noopener noreferrer" className="nsc-nav-whatsapp">Message us on WhatsApp<MessageCircle size={17} aria-hidden="true" /></a>
          </nav>
        </details>
      </div>
    </div>
  </header>;
}
